import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import { useUserLogout } from '@/model/api/user/apiUserLogout'
import * as log from '@/model/util/log/Logger'
import { useScreen } from '@/model/screen/screenTransition'

/**
 * ログアウトを実施してTOP画面遷移へ遷移する
 * @param store vuex
 * @param router vueRouter
 */
const logout = async (store: Store<StoreState>, router: Router) => {
  // api送信を実施
  const { isNormal } = await useUserLogout(router, store).post()
  if (!isNormal) {
    // 失敗した時は警告ログを出力する
    log.warn(`User logout failed.`)
  }
  // TOP画面にエラー情報を出力しないで遷移する
  useScreen().topRedirectNormal(store, router)
}

export { logout }
